import type { Camera2D } from '../hex/camera2d';
import type { Point } from '../hex/types';
import type { HexMapState } from '../render/renderer';
import { ModalManager } from '../../modal/ModalManager';

export function bindWheelController(
    canvas: HTMLCanvasElement,
    camera: Camera2D,
    state: HexMapState,
    markDirty: () => void,
): () => void {
    const modalManager = new ModalManager(state);

    const onWheel = (e: WheelEvent) => {
        e.preventDefault();
        const p: Point = { x: e.clientX, y: e.clientY };

        if (modalManager.handleScroll(p, e.deltaY)) {
            markDirty();
            return;
        }

        if (state.tutorial && state.tutorial.lockCamera && !state.tutorial.completed) {
            return;
        }

        const zoomDelta = e.deltaY < 0 ? 1.08 : 0.92;
        camera.zoomAt(p, zoomDelta);
        markDirty();
    };

    canvas.addEventListener('wheel', onWheel, { passive: false });

    return () => {
        canvas.removeEventListener('wheel', onWheel);
    };
}
